import _asyncToGenerator from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { Buyback, Signer } from '@tokenlon/sdk';
import { axios } from "../common";
export * from "./types";
export var getBuybackFee = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", axios.get("/referral/buyback/fee"));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getBuybackFee() {
    return _ref.apply(this, arguments);
  };
}();
export var getContractFeeBalanceLists = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", axios.get("/referral/buyback/tokens"));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getContractFeeBalanceLists() {
    return _ref2.apply(this, arguments);
  };
}();
export var getBuybackInterval = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(chainId, provider) {
    var buyback;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(!chainId || !provider)) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return");

          case 2:
            _context3.next = 4;
            return new Buyback(chainId);

          case 4:
            buyback = _context3.sent;
            return _context3.abrupt("return", buyback.getBuybackInterval(provider));

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getBuybackInterval(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();
export var postBuyback = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(provider, tokenAddress, feeAmountForBuyback, minLonAmount, ethTxOptions, callback) {
    var signer, txRaw;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(!provider || !tokenAddress)) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return");

          case 2:
            signer = new Signer(provider, 'web', {
              afterProcessEthTx: callback
            });
            _context4.next = 5;
            return signer.sendBuyback(tokenAddress, feeAmountForBuyback, minLonAmount, ethTxOptions);

          case 5:
            txRaw = _context4.sent;
            return _context4.abrupt("return", signer.sendTransaction(txRaw));

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function postBuyback(_x3, _x4, _x5, _x6, _x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}();
export var getBuybackHistory = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", axios.get('/referral/lon/buyback_history'));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function getBuybackHistory() {
    return _ref5.apply(this, arguments);
  };
}();